import { View, Image } from "react-native";
import React from "react";

export default function index() {
  return (
    <View>
      <Image
        source={require("./banner.png")}
        style={{ width: "100%", height: 100 }}
        resizeMode="cover"
      ></Image>
    </View>
  );
}
